export function DateFormatageSend(defaultValue: any) {
    const parts = defaultValue
        .toLocaleDateString("fr-FR", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
        })
        .split("/"); // Diviser la date en parties : jour, mois, année
    const formattedDate = `${parts[2]}-${parts[1].padStart(
        2,
        "0"
    )}-${parts[0].padStart(2, "0")}`;

    return formattedDate;
}

export const formatDate = (date: string) => {
    const newDate = new Date(date)
    const year = newDate.getFullYear();
    const month = (newDate.getMonth() + 1).toString().padStart(2, '0');
    const day = newDate.getDate().toString().padStart(2, '0');
    return `${day}-${month}-${year}`;
};
export function DateFormatage(inputDate: string) {
    if (inputDate !== undefined && inputDate !== "") {
        const parts = inputDate.split("-");
        if (parts.length === 3) {
            const [part1, part2, part3] = parts;
            const formattedDate = `${part3}-${part2}-${part1}`;
            return formattedDate;
        }
    }
    return inputDate;
}
export const formatDateComplet = (date: string) => {
    const newDate = new Date(date);
    const options: Intl.DateTimeFormatOptions = {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    };
    if (newDate) {
        return new Intl.DateTimeFormat('fr-FR', options).format(newDate);
    }


};
